export default {
    ACQUIRED_FORMULAE: 'Acquired Formulae',
    ALCHEMY_FORMULAE: 'Alchemy Formulae',
    ALL_FORMULAE: 'All Formulae',
    AMMUNITION_DIAGRAMS: 'Ammunition Diagrams',
    ARMOR_DIAGRAMS: 'Armor Diagrams',
    ARMOR_ENHANCEMENT_DIAGRAMS: 'Armor Enhancement Diagrams',

    BLADE_OILS: 'Blade Oils',

    CRAFTING_COMPONENTS: 'Crafting Components',
    CRAFTING_DIAGRAMS: 'Crafting Diagrams',

    DECOCTIONS: 'Decoctions',
    DIMERITIUM: 'Dimeritium',
    DMG_POISONS: '5e Poisons',
    DND_HOMEBREW: 'D&D 5e Homebrew',

    ELDERFOLK_CRAFTING_DIAGRAMS: 'Elderfolk Crafting Diagrams',

    FAST_ATTACK: 'Fast Attack',
    FIRE: 'Fire',

    GRANDMASTER_DIAGRAMS: 'Grandmaster Diagrams',

    INGREDIENT_DIAGRAMS: 'Ingredient Diagrams',
    INGREDIENT_GENERATOR: 'Ingredient Generator',
    INGREDIENTS: 'Ingredients',

    JOURNEYMAN_DIAGRAMS: 'Jorneyman Diagrams',
    JOURNEYMAN_FORMULAE: 'Journeyman Formulae',

    KINETIC_DAMAGE: 'Kinetic Damage',

    LAB: 'Lab',

    MASTER_DIAGRAMS: 'Master Diagrams',
    MASTER_FORMULAE: 'Master Formulae',
    MEMORIZED_FORMULAE: 'Memorized Formulae',

    NOVICE_DIAGRAMS: 'Novice Diagrams',
    NOVICE_FORMULAE: 'Novice Formulae',

    POTIONS: 'Potions',

    RECIPES: 'Recipes',
    REPORT_BUG_REQUEST_FEATURE: 'Report Bug/Request Feature',

    SATCHEL: 'Satchel',
    SETTINGS: 'Settings',
    SILVER: 'Silver',
    STEEL: 'Steel',
    STRONG_ATTACK: 'Strong Attack',

    WEAPONS_OF_TOUSSAINT_DIAGRAMS: 'Weapons of Toussaint Diagrams',
    WEAPON_DIAGRAMS: 'Weapon Diagrams', 
    WITCHER: 'Witcher',
    WITCHER_RECIPES: 'Witcher Recipes',
    WITCHER_BREWS: 'Witcher Brews',
}